import { render, staticRenderFns } from "./LaudoBenfeitorias.vue?vue&type=template&id=3e2d5d10&scoped=true&lang=pug"
import script from "./LaudoBenfeitorias.vue?vue&type=script&lang=js"
export * from "./LaudoBenfeitorias.vue?vue&type=script&lang=js"
import style0 from "./LaudoBenfeitorias.vue?vue&type=style&index=0&id=3e2d5d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d5d10",
  null
  
)

export default component.exports